import React, { useRef, useState } from "react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./tooltip";

function TooltipWithShortDelay({ children, content }) {
  const [open, setOpen] = useState(false);
  const timeoutRef = useRef(null);

  // Для десктопа — ховер
  const handleMouseEnter = () => {
    if (window.matchMedia("(hover: hover)").matches) {
      timeoutRef.current = setTimeout(() => setOpen(true), 200);
    }
  };

  const handleMouseLeave = () => {
    if (window.matchMedia("(hover: hover)").matches) {
      clearTimeout(timeoutRef.current);
      setOpen(false);
    }
  };

  // Для мобильных — тап
  const handleTouchStart = (e) => {
    if (!window.matchMedia("(hover: hover)").matches) {
      e.preventDefault();
      e.stopPropagation();
      setOpen((prev) => !prev);
    }
  };

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger asChild>
          <span
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onTouchStart={handleTouchStart}
            onClick={(e) => {
              // Предотвращаем всплытие, чтобы не закрывалось
              if (!window.matchMedia("(hover: hover)").matches) {
                e.preventDefault();
                e.stopPropagation();
              }
            }}
            style={{ display: "inline-flex", cursor: "pointer" }}
          >
            {children}
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs text-sm text-left">
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default TooltipWithShortDelay;
